var ellipsis = {

	editorial: {
		item: $('.module-editorial:not(.module-editorial-2col):not(.editorial-feed)'),
		item2col: $('.module-editorial-2col'),
		feed: $('.editorial-feed-article'),
		header: $('.module-editorial-header'),
		title:  $('.module-editorial-content header'),
		image: $('.module-editorial-img'),
		copy: $('.module-editorial-copy'),
		footer: $('.module-editorial-footer'),
		applyEl: $('.module-editorial-copy.ellipsis'),
		feedApplyEl: $('.ellipsis-feed'),

		setup: {


			single: function() {

				ellipsis.editorial.item.each(function(){

					if ($(this).find(ellipsis.editorial.copy).length) {

						// Elements
						var $img = $(this).find(ellipsis.editorial.image);
						var $header = $(this).find(ellipsis.editorial.header);
						var $title = $(this).find(ellipsis.editorial.title);
						var $footer = $(this).find(ellipsis.editorial.footer);
						var $copy = $(this).find(ellipsis.editorial.copy);

						// Element heights
						var containerHeight = 370;
						var imgHeight = 212;
						var headerHeight = $header.height();
						var titleHeight = $title.height();
						var footerHeight = $footer.height();

						var copyHeight = containerHeight - headerHeight - titleHeight - 15;

						if ( $img.length > 0 ) { copyHeight -= imgHeight; }

						if ( $footer.length > 0 ) { copyHeight -= footerHeight; }

						$copy.css('height', copyHeight);
					}
				});
			},

			col2: function() {

				ellipsis.editorial.item2col.each(function(){

					var container = 370;
					var title = $(this).find(ellipsis.editorial.title).height();
					var footer = $(this).find(ellipsis.editorial.footer);
					var copyHeight = 'auto';

					if (footer.length > 0) {
						copyHeight = container - title - 15 - (footer.height());
					} else {
						copyHeight = container - title - 15;
					}

					$(this).find(ellipsis.editorial.copy).css('height', copyHeight);
				});
			},

			feed: function() {

				ellipsis.editorial.feed.each(function(){
					var content = $('.whats-on-intro');
					var container = 100;
					var title = $(this).find('header').height();
					var copyHeight = container - title - 4;

					$(this).find(content).css('height', copyHeight);
				});
			}
		},

		getLarge: function() {
			ellipsis.editorial.setup.single();
			ellipsis.editorial.setup.col2();
		},

		loadApply: function() {
			ellipsis.editorial.getLarge();
			ellipsis.editorial.applyEl.dotdotdot();
		},

		resizeApply: function() {
			ellipsis.editorial.getLarge();
			ellipsis.editorial.applyEl.trigger('update');
		},

		undoEllipsis: function() {
			ellipsis.editorial.applyEl.trigger('destroy');
			ellipsis.editorial.applyEl.removeAttr('style');
		},

		loadApplyFeed: function() {
			ellipsis.editorial.setup.feed();
			ellipsis.editorial.feedApplyEl.dotdotdot();
		},

		resizeApplyFeed: function() {
			ellipsis.editorial.setup.feed();
			ellipsis.editorial.feedApplyEl.trigger('update');
		},

		init: function() {
			if (windowWidth >= tablet && ellipsis.editorial.applyEl.length > 0) {
				ellipsis.editorial.loadApply();
				setTimeout(function() {
					ellipsis.editorial.resizeApply();
				},50);
			}
			if (ellipsis.editorial.feedApplyEl.length > 0) {
				ellipsis.editorial.loadApplyFeed();
				setTimeout(function() {
					ellipsis.editorial.resizeApplyFeed();
				},50);
			}
		}
	},

	freeText: {
		item: $('.module-free-text'),
		header: $('.module-free-text-header'),
		copy: $('.module-free-text-copy:not(.variable-height)'),
		more: $('.find-more'),
		applyEl: $('.module-free-text-copy.ellipsis'),

		setup: function() {

			ellipsis.freeText.item.each(function(){

				if ($(this).find(ellipsis.freeText.copy).length) {

					var container = 370;
					var title = $(this).find(ellipsis.freeText.header).height();
					var more = $(this).find(ellipsis.freeText.more).height();
					var copyHeight = container - title - more;

					if ($(this).hasClass('free-text-background')) {
						copyHeight -= 80;
					} else {
						copyHeight -= 28;
					}

					$(this).find(ellipsis.freeText.copy).css('height', copyHeight);
				}
			});
		},

		getHEight: function() {
			ellipsis.freeText.setup();
		},

		loadApply: function() {
			ellipsis.freeText.getHEight();
			ellipsis.freeText.applyEl.dotdotdot();
		},

		resizeApply: function() {
			ellipsis.freeText.getHEight();
			ellipsis.freeText.applyEl.trigger('update');
		},

		undoEllipsis: function() {
			ellipsis.freeText.applyEl.trigger('destroy');
			ellipsis.freeText.applyEl.removeAttr('style');
		},

		init: function() {
			if (windowWidth >= tablet && ellipsis.freeText.applyEl.length > 0) {
				ellipsis.freeText.loadApply();
			}
		}
	},

	promoTextLong: {
		item: $('.promo-text-long'),
		header: $('.promo-text-long .module-title'),
		copy: $('.ellipsis'),
		footer: 150,

		setup: function() {

			ellipsis.promoTextLong.item.each(function(){

				if ($(this).find(ellipsis.promoTextLong.copy).length) {

					var container = 370;
					var title = $(this).find(ellipsis.promoTextLong.header).height();
					var copyHeight = container - title - ellipsis.promoTextLong.footer;

					$(this).find(ellipsis.promoTextLong.copy).css('height', copyHeight);
				}
			});
		},

		getHEight: function() {
			ellipsis.promoTextLong.setup();
		},

		loadApply: function() {
			ellipsis.promoTextLong.getHEight();
			ellipsis.promoTextLong.copy.dotdotdot();
		},

		resizeApply: function() {
			ellipsis.promoTextLong.getHEight();
			ellipsis.promoTextLong.copy.trigger('update');
		},

		undoEllipsis: function() {
			ellipsis.promoTextLong.copy.trigger('destroy');
			ellipsis.promoTextLong.copy.removeAttr('style');
		},

		init: function() {
			if (windowWidth >= tablet && ellipsis.promoTextLong.copy.length > 0) {
				ellipsis.promoTextLong.loadApply();
			}
		}
	},
	// treat: {
	// 	copy: $('.treat-inner'),

	// 	applyEl: function() {
	// 		if (ellipsis.treat.copy.length) {
	// 			ellipsis.treat.copy.find('p').each(function(){
	// 				$(this).dotdotdot();
	// 			});
	// 		}
	// 	},

	// 	resizeApply: function() {
	// 		if (ellipsis.treat.copy.length) {
	// 			ellipsis.treat.copy.find('p').each(function(){
	// 				$(this).trigger('update');
	// 			});
	// 		}
	// 	}
	// },

	removeEmpty: function() {
		var applyEl = $('.ellipsis');

		applyEl.each(function() {
			var _this = $(this);
			var ellipsisCheck = _this.text().trim().length;

			if (ellipsisCheck === 3) {
				_this.empty();
			}
		});
	},

	init: function() {
		ellipsis.freeText.init();
		ellipsis.editorial.init();
		ellipsis.promoTextLong.init();
		ellipsis.removeEmpty();
		// ellipsis.treat.applyEl();
	}
};